<template>
  <div class="source">
    <h3>{{ $t('question_source') }}</h3>
    <div class="type">
      <div v-for="(item, i) in services" :key="item.id">
        <router-link
          :to="{ path: 'service', query: { id: item.id, name: item.name } }"
        >
          <div
            class="image"
            :class="item.icon || icons[i % icons.length]"
          ></div>
          <p>{{ item.name }}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { isMC } from '@/utils'
import { mapState } from 'vuex'

export default {
  name: 'source-type',
  data() {
    return {
      icons: ['i-ios', 'i-andriod', isMC() ? 'i-weshop' : 'i-bhb', 'i-print'],
    }
  },
  computed: {
    ...mapState({
      services: (s) => s.groupList,
    }),
    // services() {
    //   return [
    //     {
    //       id: 1,
    //       name: i18n.t('i_ios'),
    //       icon: 'i-ios',
    //     },
    //     {
    //       id: 2,
    //       name: i18n.t('i_andriod'),
    //       icon: 'i-andriod',
    //     },
    //     isMC()
    //       ? {
    //         id: 75,
    //         name: i18n.t('i_weshop'),
    //         icon: 'i-weshop',
    //       }
    //       : {
    //         id: 3,
    //         name: '补货宝',
    //         icon: 'i-bhb',
    //       },
    //     {
    //       id: 4,
    //       name: i18n.t('i_print'),
    //       icon: 'i-print',
    //     },
    //   ]
    // },
  },
}
</script>

<style lang="scss">
@import '../../../style/func.scss';

.source {
  background-color: #fff;
  overflow: hidden;

  h3 {
    font-size: px2rem(16px);
    font-weight: normal;
    margin: 0;
    padding: px2rem(12px);
  }
  .type {
    display: flex;
    justify-content: space-around;
    text-align: center;
    padding: px2rem(20px) px2rem(12px) px2rem(16px);
    border-top: 1px solid #f2f2f2;
    border-bottom: 1px solid #dddde0;

    > div {
      width: 24%;

      .image {
        width: 50%;
        margin: 0 auto;
        padding-top: 50%;
        // border-radius: 100%;
        background-size: auto 80%;
        background-repeat: no-repeat;
        background-position: center center;

        &.i-ios {
          background-image: url(../../../assets/apple.png);
        }
        &.i-andriod {
          background-image: url(../../../assets/andriod.png);
        }
        &.i-bhb {
          background-image: url(../../../assets/buhuobao.png);
        }
        &.i-weshop {
          background-size: 100% auto;
          background-image: url(../../../assets/weshop.png);
        }
        &.i-print {
          background-image: url(../../../assets//pinter.png);
        }
      }
      p {
        margin-top: px2rem(8px);
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help-center/components/ProblemSource.vue